import * as constants from "./deviceType.utils";
import {
  DEVICE_LARGE_UPPER_BOUND,
  DEVICE_MEDIUM_UPPER_BOUND,
  DEVICE_SMALL_UPPER_BOUND
} from "./style/settings";

export function getDeviceInfo() {
  const width: number = window.innerWidth;
  const height: number = window.innerHeight;

  return {
    width,
    height,
    userAgent: navigator.userAgent,
    orientation:
      width >= height
        ? constants.ORIENTATION_LANDSCAPE
        : constants.ORIENTATION_PORTRAIT,
    deviceType: getDeviceType(width)
  };
}

function getDeviceType(width) {
  if (width <= DEVICE_SMALL_UPPER_BOUND) return constants.DEVICE_SMALL;
  if (width <= DEVICE_MEDIUM_UPPER_BOUND) return constants.DEVICE_MEDIUM;
  if (width <= DEVICE_LARGE_UPPER_BOUND) return constants.DEVICE_LARGE;
  return constants.DEVICE_XLARGE;
}
